import $ from './app/jquery-shim.js';
import Utils from './app/utils.js';
import Accordion from './app/accordion.js';
import Anchor from './app/anchor.js';
import FixedHeader from './app/fixedheader.js';
import HeightLine from './app/heightline.js';
import ResponsiveTable from './app/responsive-table.js';
import Slidebar from './app/slidebar.js';
import Tab from './app/tab.js';
import CurrentNav from './app/current-nav.js';
// import buildFormat from './app/format.js';
import OwlCarousel from 'owl.carousel';
import modaalCss from 'modaal/dist/css/modaal.css';
import modaal from 'modaal';

import ScrollReveal from "scrollreveal";

import slick from "slick-carousel/slick/slick.min.js";
import slickCss from "slick-carousel/slick/slick.css";
import slickTheme from "slick-carousel/slick/slick-theme.css";

import fontAwesome from "font-awesome/scss/font-awesome.scss"
import OwlCss from "owl.carousel/dist/assets/owl.carousel.css"
import OwlThemeCss from "owl.carousel/dist/assets/owl.theme.default.css"

class App {
  constructor() {
    this.Utils = new Utils();
    this.Accordion = new Accordion();
    this.Anchor = new Anchor();
    this.FixedHeader = new FixedHeader();
    // this.HeightLine = new HeightLine();
    this.ResponsiveTable = new ResponsiveTable();
    this.Slidebar = new Slidebar();
    this.CurrentNav = new CurrentNav();
    this.Tab = new Tab();

    //SPメニューの高さ取得
    function menuHight() {
      var win = $(window).innerWidth();
      if (win > 750) {
        return false;
      }

      var $smpHeaderHeight = $('.l-header').height();
      var windowHeight = window.innerHeight;
      var winH = windowHeight - $smpHeaderHeight;

      console.log($smpHeaderHeight);

      //動かすターゲットを取得
      var targetSlidebarWrap = $('.c-slidebar-menu'),
        targetSlidebarMenu = $('.c-slidebar__parent'),
        targetSlidebarBtn = $('.c-slidebar-menu__parent');


      //いざ実行(クリックしたら処理を実行する)
      targetSlidebarBtn.on('click', function () {
        $('.c-slidebar-menu').toggleClass('is-active');

      });
    }

    //フッターメニューSPスライドx
    function menuSlide() {
      var win = $(window).innerWidth();
      if (win >= 750) {
        return false;
      }

      var $menuTitle = $('.l-footer-normal__menutitle a');
      for (var i = 0; i < $menuTitle.length; i++) {
        $($menuTitle[i]).replaceWith("<span>" + $($menuTitle[i]).text() + "</span>")
      }


      // $(this).children("").replaceWith("<span>"+$(this).text()+"</span>");


      $('.l-footer-normal__block').on('click', function () {
        $(this).children(".l-footer-normal__menutitle").toggleClass('is-open');
        $(this).children(".l-footer-normal__menulist.is-sub").slideToggle();
      });
    }

    //owlcarousel
    function owlCarousel() {
      var owls = $('.owl-carousel');
      if (owls.length === 0) {
        return false
      }
      //->スライダー
      owls.imagesLoaded(function () {
        $('.c-main-visual__slider').owlCarousel({
          items: 1,
          margin: 0,
          dots: false,
          loop: true,
          nav: false,
          autoplayHoverPause: false,
          autoplay: true,
          autoplaySpeed: 500,
          autoWidth: false,
          autoHeight: false,
          center: true,
          animateOut: 'fadeOut',
        });
      });
      //->カード_カルーセル
      owls.imagesLoaded(function () {
        $('.js-card-slider').owlCarousel({
          margin: 36,
          dots: true,
          loop: true,
          nav: true,
          autoplayHoverPause: true,
          autoplay: true,
          autoplaySpeed: 500,
          autoWidth: false,
          autoHeight: false,
          center: true,
          navText: ['<i class="fa fa-angle-left" aria-hidden="true"></i>', '<i class="fa fa-angle-right" aria-hidden="true"></i>'],
          responsive: {
            // breakpoint from 0 up
            0: {
              items: 1,
            },
            // breakpoint from 750 up
            750: {
              items: 3,
            }
          }
        });
      });
    }


    // .c-vertical-card のホバーした時のテキストをクローンする処理
    function textClone() {
      var target = $('.js-clone-text');
      var appendArea = $('.js-append-area');
      for (var i = 0; i < target.length; i++) {
        target.eq(i).clone().appendTo(appendArea.eq(i));
      }
    }

    function modaal() {
      $(".js-imagemodal").modaal({
        type: 'image'
      });
      $(".c-composite-search__block").modaal({
        content_source: '#inline'
      });
      $(".l-footer__menulist li.is-modal").modaal({
        content_source: '#inline'
      });
    }

    function searchModal() {
      $('.c-composite-search__block[data-search-target="price"]').on('click', function () {
        $('.c-search-modal__content').hide();
        $('.c-search-modal__title').removeClass('is-open');
        $('.c-search-modal__title.is-price').addClass('is-open');
        $('.c-search-modal__title.is-price').next('.c-search-modal__content').slideDown(200);
      });
      $('.c-composite-search__block[data-search-target="yield"]').on('click', function () {
        $('.c-search-modal__content').hide();
        $('.c-search-modal__title').removeClass('is-open');
        $('.c-search-modal__title.is-yield').addClass('is-open');
        $('.c-search-modal__title.is-yield').next('.c-search-modal__content').slideDown(200);
      });
      $('.c-composite-search__block[data-search-target="width"]').on('click', function () {
        $('.c-search-modal__content').hide();
        $('.c-search-modal__title').removeClass('is-open');
        $('.c-search-modal__title.is-width').addClass('is-open');
        $('.c-search-modal__title.is-width').next('.c-search-modal__content').slideDown(200);
      });

      $('.c-search-modal__title').on('click', function () {
        $(this).toggleClass('is-open');
        $(this).next(".c-search-modal__content").slideToggle(200);
      });
    }



    var growApp = {

      // お部屋
      slick: function () {
        $('.js-slider-main').slick({
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: true,
          asNavFor: '.js-thumb',
          dots: true,
          infinite: true,
          appendDots: '.c-tab-slider__dots'
        });
        $('.js-thumb').slick({
          slidesToShow: 7,
          slidesToScroll: 1,
          asNavFor: '.js-slider-main',
          centerMode: true,
          focusOnSelect: true,
          centerPadding: 0,
          infinite: true,
          responsive: [
            {
              breakpoint: 750,
              settings: {
                slidesToShow: 5,
                slidesToScroll: 1,
              }
            },
          ]
        });
        $('.c-tabs__navs.js-tabs-nav li:nth-child(1)').on('click', function () {
          $('.js-slider-main').slick("refresh");
          $('.js-thumb').slick("refresh");
        });
        $('.c-tabs__navs.js-tabs-nav li:nth-child(2)').on('click', function () {
          $('.js-slider-main2').slick("refresh");
          $('.js-thumb2').slick("refresh");
        });


        // サムネイルの'slidesToShow'より少ない場合の処理
        $('.js-slider-main').on('beforeChange', function (event, slick, currentSlide, nextSlide) {
          if ($('.js-thumb .js-thumb-item').length < 8) {
            $('.js-thumb').slick('slickSetOption', 'centerMode', false, true);
            $('.js-thumb').slick('slickSetOption', 'focusOnSelect', true, false);
          }
          // if ($(window).innerWidth() <= 750 && $('.js-thumb .js-thumb-item').length < 6) {
          //   $('.js-thumb').slick('slickSetOption', 'centerMode', false, true);
          //   $('.js-thumb').slick('slickSetOption', 'focusOnSelect', false, true);
          // }
        });
      },

      // 外観・共用部
      slick2: function () {
        $('.js-slider-main2').slick({
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: true,
          asNavFor: '.js-thumb2',
          dots: true,
          infinite: true,
          appendDots: '.c-tab-slider__dots2'
        });

        $('.js-thumb2').slick({
          slidesToShow: 7,
          slidesToScroll: 1,
          asNavFor: '.js-slider-main2',
          centerMode: true,
          focusOnSelect: true,
          centerPadding: 0,
          infinite: true,
          responsive: [
            {
              breakpoint: 750,
              settings: {
                slidesToShow: 5,
              }
            },
          ]
        });
        $('.js-slider-main2').on('beforeChange', function (event, slick, currentSlide, nextSlide) {
          if ($('.js-thumb2 .js-thumb-item').length < 8) {
            $('.js-thumb2').slick('slickSetOption', 'centerMode', false, true);
            $('.js-thumb2').slick('slickSetOption', 'focusOnSelect', true, false);
          }
        });


      },

      reveal: function() {
        //- スクロールリーバル
        window.sr = ScrollReveal({duration: 600,mobile:true});
        function domEach(items, callback) {
          if (typeof items === "string") {
            var items = $(items);
          }
          for (var i = 0; i < items.length; i++) {
            var item = items[i];
            // callback = callback.bind(item)
            callback(i, item);
          }
        }


        sr.reveal(".c-main-visual__text", {scale: 1, duration: 1500,delay: 1200,origin:'left',distance: '20px',easing: 'ease'}, 100);
        sr.reveal(".c-main-visual__subtext", {scale: 1, duration: 1500,delay: 2000,origin:'left',distance: '20px',easing: 'ease'}, 100);
        sr.reveal(".l-page-header__title", {scale: 1, duration: 800,origin:'left',distance: '20px',easing: 'ease'}, 100);
        sr.reveal(".l-page-header__subtitle", {scale: 1, duration: 800,delay: 400,origin:'left',distance: '20px',easing: 'ease'}, 100);
        sr.reveal(".l-page-header__text", {scale: 1, duration: 800,delay: 600,origin:'left',distance: '20px',easing: 'ease'}, 100);
        sr.reveal(".c-front-news", {viewFactor: 0.3, scale: 1, duration: 600,delay: 0,origin:'left',distance: '20px',easing: 'ease'}, 100);
        sr.reveal(".c-case-box__block", {viewFactor: 0.3, scale: 1, duration: 600,delay: 0,origin:'bottom',distance: '20px',easing: 'ease'}, 100);
        sr.reveal(".c-business-box__box", {viewFactor: 0.3, scale: 1, duration: 600,delay: 0,origin:'bottom',distance: '20px',easing: 'ease'}, 100);

        var blocks01 = $(".c-vertical-card__wrap, .c-card__wrap, .c-hero-block__block");
        domEach(blocks01, function (key, item) {
          sr.reveal(item, {scale: 1,duration: 700,delay: 0,origin: 'bottom', distance: '20px'}, 200);
          sr.reveal(item.children[1], {delay: 200, scale: 1,origin: 'bottom', distance: '20px'}, 300);
          sr.reveal(item.children[2], {delay: 400, scale: 1,origin: 'bottom', distance: '20px'}, 300);
          sr.reveal(item.children[3], {delay: 600, scale: 1,origin: 'bottom', distance: '20px'}, 300);
          sr.reveal(item.children[4], {delay: 800, scale: 1,origin: 'bottom', distance: '20px'}, 300);
          sr.reveal(item.children[5], {delay: 1000, scale: 1,origin: 'bottom', distance: '20px'}, 300);
          sr.reveal(item.children[6], {delay: 1200, scale: 1,origin: 'bottom', distance: '20px'}, 300);
        });

        var blocks02 = $(".c-flow__wrap");
        domEach(blocks02, function (key, item) {
          sr.reveal(item, {scale: 1,duration: 700,delay: 0,origin: 'left', distance: '20px'}, 200);
          sr.reveal(item.children[1], {delay: 200, scale: 1,origin: 'left', distance: '20px'}, 300);
          sr.reveal(item.children[2], {delay: 400, scale: 1,origin: 'left', distance: '20px'}, 300);
          sr.reveal(item.children[3], {delay: 600, scale: 1,origin: 'left', distance: '20px'}, 300);
          sr.reveal(item.children[4], {delay: 800, scale: 1,origin: 'left', distance: '20px'}, 300);
          sr.reveal(item.children[5], {delay: 1000, scale: 1,origin: 'left', distance: '20px'}, 300);
          sr.reveal(item.children[6], {delay: 1200, scale: 1,origin: 'left', distance: '20px'}, 300);
        });

      },
    };

    function startVideo() {
      var win = $(window).innerWidth();

      if ($("#top-video").length <= 0) {
        return false;
      }

      // if (win <= 750) {
      //   //750px未満は再生しない
      //   return false;
      // } //変数宣言


      var videoObj = document.getElementById("top-video"); //video

      if (videoObj) {
        //アニメーションループ処理
        var animLoopFunction = function animLoopFunction() {
          videoObj.play(); //動画再生
        }; //実行


        animLoopFunction(); //動画が終わったタイミングで発火 初期化と、ループ

        videoObj.addEventListener("ended", function () {
          animLoopFunction(); //初期化とアニメーションループ
        }, false);
      }
      var getWindowMovieHeight = function() {
        // ここでブラウザの縦横のサイズを取得します。
        var offset_left = 117; // PC版の場合には左側に117pxアクため
        var windowSizeHeight = $(window).outerHeight();
        var windowSizeWidth = $(window).outerWidth();

        // メディアの縦横比に合わせて数値は変更して下さい。(メディアのサイズが width < heightの場合で書いています。逆の場合は演算子を逆にしてください。)
        var windowMovieSizeWidth = windowSizeHeight * 1.76388889;
        var windowMovieSizeHeight = windowSizeWidth / 1.76388889;
        var windowMovieSizeWidthLeftMargin = (windowMovieSizeWidth - windowSizeWidth) / 2;
        if(windowSizeWidth > 1200){
          windowMovieSizeWidthLeftMargin += offset_left;
        }

        if (windowMovieSizeHeight < windowSizeHeight) {
          // 横幅のほうが大きくなってしまう場合にだけ反応するようにしています。
          // $("#top-video").css({left: -windowMovieSizeWidthLeftMargin});
        }
      };

      // 以下画面の可変にも対応できるように。
      $(window).on('load', function(){
        getWindowMovieHeight();
      });

      $(window).on('resize', function(){
        getWindowMovieHeight();
      });

    }

    $(function () {
      menuSlide();
      owlCarousel();
      textClone();
      modaal();
      searchModal();
      startVideo();

      growApp.reveal();
      growApp.slick();
      $('.is-switch').one('click', function () {
        if ($('.c-tabs__content').hasClass('is-active')) {
          growApp.slick2();
        }
      });
      if ($(".c-tab-slider").find("*[data-tab-target=1]").hasClass("is-active")) {
        growApp.slick2();
      }
    });
  }
}

window.GApp = new App();
